var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isExistSoftVersion
    ? _c(
        "div",
        {
          staticClass: "d-inline-flex",
          style: { verticalAlign: "middle" },
          attrs: { "data-qa": "soft_version_icon" },
        },
        [
          _c("SoftVersionImage", {
            ref: "tooltipTrigger",
            attrs: { image: _vm.softData.image },
          }),
          _vm._v(" "),
          _c("div", { ref: "tooltipContent", staticClass: "d-none" }, [
            _c("div", { staticClass: "text-subtitle-1 mb-1" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("Подключена версия", { ns: _vm.$i18next.language })
                  ) +
                  " " +
                  _vm._s(_vm.softData.translate) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "text-body-1 pl-6" },
              _vm._l(_vm.listBenefits, function (benefit, i) {
                return _c("li", { key: i }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t(`${benefit}`, { ns: _vm.$i18next.language })
                      ) +
                      "\n      "
                  ),
                ])
              }),
              0
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }